import Ajv from "ajv";
import addFormats from "ajv-formats";

export const ajv = new Ajv({
  allErrors: true,
  verbose: true,
  coerceTypes: "array",
});
addFormats(ajv, ["uuid", "iso-date-time"]);
